import type { EvidenceGrade, MoneyRange } from '@wolhasudang/shared';

export interface AnnualMonthResult { month: string; evidenceGrade: EvidenceGrade; allowanceSubtotal: MoneyRange }

export interface AnnualSummary {
  recordedMonthCount: number;
  missingMonthCount: number;
  exactTotal: number;
  rangedTotal: MoneyRange;
  gradeCounts: Record<EvidenceGrade, number>;
}

export function aggregateAnnualResults(rows: AnnualMonthResult[], windowSize = 12): AnnualSummary {
  const window = rows.slice(-windowSize);
  const gradeCounts = { A: 0, B: 0, C: 0 };
  let exactTotal = 0;
  const rangedTotal = { min: 0, max: 0 };
  for (const row of window) {
    gradeCounts[row.evidenceGrade] += 1;
    if (row.evidenceGrade === 'A') exactTotal += row.allowanceSubtotal.min;
    if (row.evidenceGrade === 'B') {
      rangedTotal.min += row.allowanceSubtotal.min;
      rangedTotal.max += row.allowanceSubtotal.max;
    }
  }
  return { recordedMonthCount: window.length, missingMonthCount: Math.max(0, windowSize - window.length), exactTotal, rangedTotal, gradeCounts };
}

export function shareCardAmountVisible(requested: boolean, grade: EvidenceGrade): boolean {
  return requested && grade !== 'C';
}

export function safeShareText(month: string, shiftCount: number, nightCount: number): string {
  return `${month} 근무 ${shiftCount}일 · 나이트 ${nightCount}회`;
}
